export default "assets/map_image-cd7e601e.jpg";